// extracted by mini-css-extract-plugin
export var addTagButtonOverride = "_bl-b";
export var colorBlue = "_bl-8";
export var colorDot = "_bl-0";
export var colorDotLarge = "_bl-2";
export var colorDotSmall = "_bl-1";
export var colorGreen = "_bl-7";
export var colorGrey = "_bl-3";
export var colorOrange = "_bl-5";
export var colorPink = "_bl-a";
export var colorPurple = "_bl-9";
export var colorRed = "_bl-4";
export var colorYellow = "_bl-6";